import React from "react";
import Modal from "react-modal";
import styles from "./UserInfoModal.module.css";

Modal.setAppElement("#root");

function UserInfoModal({ isOpen, toggle, userInfo }) {
  const initial = (userInfo?.email || "?").slice(0, 1).toUpperCase();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={toggle}
      contentLabel="User Info"
      className={styles.modal}
      overlayClassName={styles.overlay}
      closeTimeoutMS={150}
    >
      <button onClick={toggle} className={styles.close} aria-label="Close">×</button>

      <div className={styles.head}>
        <div className={styles.avatar} aria-hidden="true">{initial}</div>
        <div>
          <h2 className={styles.title}>Account</h2>
          <p className={styles.sub}>Signed-in profile</p>
        </div>
      </div>

      <dl className={styles.kv}>
        <div><dt>Name</dt><dd>{userInfo?.name || "—"}</dd></div>
        <div><dt>Email</dt><dd>{userInfo?.email || "—"}</dd></div>
        <div>
          <dt>Wallet</dt>
          <dd className="mono">{userInfo?.publicAddress || "—"}</dd>
        </div>
        {userInfo?.issuer && (
          <div><dt>Issuer</dt><dd className="mono">{userInfo.issuer}</dd></div>
        )}
        {userInfo?.location && <div><dt>Location</dt><dd>{userInfo.location}</dd></div>}
      </dl>

      <div className={styles.actions}>
        <button className="btn btn-ghost" onClick={toggle}>Close</button>
      </div>
    </Modal>
  );
}

export default UserInfoModal;
